(() => {
  'use strict';
  const template = document.getElementById('dac-search-card-actions');
  if (!template || template.dataset.connected) return;
  template.dataset.connected = 'true';
  const buttonSelector = '.dac-search-wishlist';
  let query;
  let sdk;
  let observedRoot;
  const numericId = value => /^[1-9]\d*$/.test(String(value || '')) ? String(value) : '';
  const observer = new MutationObserver(records => {
    for (const record of records) {
      if (record.type === 'attributes' && record.target.matches(buttonSelector)) syncState(record.target);
      if (record.type === 'childList') {
        const button = record.target.closest?.('.snize-add-to-cart-button');
        if (button) normalizePurchaseLabel(button);
      }
    }
  });

  function syncState(button) {
    const ready = button.classList.contains('swym-loaded');
    const holder = button.closest('.dac-search-card-actions');
    if (holder) holder.hidden = !ready;
    const pressed = String(button.classList.contains('swym-added'));
    if (button.getAttribute('aria-pressed') !== pressed) button.setAttribute('aria-pressed', pressed);
    const label = template.dataset.saveLabel.replace('__PRODUCT__', button.dataset.dacProductTitle);
    if (button.getAttribute('aria-label') !== label) button.setAttribute('aria-label', label);
    if (ready && button.dataset.restoreFocus) {
      delete button.dataset.restoreFocus;
      if (document.activeElement === document.body) button.focus({preventScroll: true});
    }
  }

  function normalizePurchaseLabel(button) {
    const walker = document.createTreeWalker(button, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      if (/^add to cart$/i.test(node.textContent.trim()) && node.textContent.trim() !== template.dataset.addLabel) {
        node.textContent = node.textContent.replace(/add to cart/i, template.dataset.addLabel);
      }
    }
  }

  function identity(card) {
    const productId = numericId(card.dataset.originalProductId);
    const link = card.querySelector('a.snize-view-link');
    if (!productId || !link) return null;
    let product;
    let url;
    try {
      product = query(card).data('snize_item_data');
      url = new URL(link.href, location.href);
    } catch (_) { return null; }
    if (!product || numericId(product.original_product_id || product.product_id) !== productId || url.origin !== location.origin || !/\/products\/[^/]+/.test(url.pathname)) return null;
    const selected = url.searchParams.get('variant');
    const variants = Array.isArray(product.shopify_variants) ? product.shopify_variants : [];
    const variantId = numericId(selected || product.add_to_cart_id);
    if (!variantId || (variants.length && !variants.some(variant => numericId(variant.variant_id) === variantId))) return null;
    url.search = '';
    url.hash = '';
    return {productId, variantId, url: url.href, title: card.querySelector('.snize-title')?.textContent.trim() || String(product.title || '')};
  }

  function apply() {
    const root = document.getElementById('snize_results');
    if (!root || !query) return;
    if (observedRoot !== root) {
      observer.disconnect();
      observedRoot = root;
      observer.observe(root, {subtree: true, childList: true, attributes: true, attributeFilter: ['class']});
    }
    root.querySelectorAll('.snize-add-to-cart-button').forEach(normalizePurchaseLabel);
    if (!sdk) return;
    root.querySelectorAll('li.snize-product[data-original-product-id]').forEach(card => {
      const data = identity(card);
      let holder = card.querySelector(':scope > .dac-search-card-actions');
      let button = holder?.querySelector(buttonSelector);
      if (!data) { holder?.remove(); return; }
      const otherButton = card.querySelector('.swym-button:not(.dac-search-wishlist)');
      if (otherButton) { holder?.remove(); return; }
      if (button && button.dataset.productId === data.productId && button.dataset.variantId === data.variantId && button.dataset.productUrl === data.url) {
        button.dataset.dacProductTitle = data.title;
        syncState(button);
        return;
      }
      const restoreFocus = document.activeElement === button;
      holder?.remove();
      holder = template.content.firstElementChild.cloneNode(true);
      button = holder.querySelector(buttonSelector);
      button.classList.add('product_' + data.productId);
      button.dataset.productId = data.productId;
      button.dataset.variantId = data.variantId;
      button.dataset.productUrl = data.url;
      button.dataset.dacProductTitle = data.title;
      if (restoreFocus) button.dataset.restoreFocus = 'true';
      syncState(button);
      card.append(holder);
    });
    const pending = root.querySelectorAll(buttonSelector + ':not(.swym-loaded):not([data-dac-swym-queued])');
    if (pending.length) {
      try {
        sdk.initializeActionButtons('#snize_results', buttonSelector + ':not(.swym-loaded):not([data-dac-swym-queued])');
        pending.forEach(button => { button.dataset.dacSwymQueued = 'true'; syncState(button); });
      } catch (_) {}
    }
  }

  function connectSearch() {
    const next = window.Searchanise?.$;
    if (typeof next !== 'function' || next === query) return;
    if (query) query(document).off('Searchanise.ResultsUpdated.dacCardActions', apply);
    query = next;
    query(document).on('Searchanise.ResultsUpdated.dacCardActions', apply);
    apply();
  }

  document.addEventListener('Searchanise.Loaded', connectSearch);
  window.SwymCallbacks = window.SwymCallbacks || [];
  window.SwymCallbacks.push(swat => {
    if (typeof swat?.initializeActionButtons !== 'function') return;
    sdk = swat;
    apply();
  });
  connectSearch();
})();
